import { useState } from "react";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { mainReducer } from "../../store";
import LibraryPage from "./LibraryPage";

// Browsing examples must not replace the user's unsaved editor document.
const LibraryWorkspace = () => {
  const [store] = useState(() => configureStore({ reducer: mainReducer }));
  return (
    <Provider store={store}>
      <LibraryPage />
    </Provider>
  );
};

export default LibraryWorkspace;
